/** True when pending block should show Add Exercise (name + type chosen). Type is locked on first Add Exercise click. */
export function pendingBlockShowsAddExerciseButton(block: { name?: string; type?: string }): boolean {
  const name = (block.name || '').trim();
  const tl = String(block.type || '').trim().toLowerCase();
  return name !== '' && tl !== '';
}
